export default __webpack_public_path__ + "static/media/thp-mobile.862cb077.png";